import React, { memo } from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import DashboardCharts from "./DashboardCharts";
import DashboardData from "./DashboardData";

const DashboardDetails = (props) => {
  const [selectedTab, setSelectedTab] = React.useState(0);

  const handleTabChange = (event, newTab) => {
    setSelectedTab(newTab);
  };

  const CustomTabPanel = (props)=> {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={selectedTab !== index}
        {...other}
      >
        {selectedTab === index && (
          <Box sx={{ p: 2 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  };

  return (
    <Box>
      <Box>
        {props.paramterName}
      </Box>
      <Box>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs value={selectedTab} onChange={handleTabChange}>
            <Tab label="Table" />
            <Tab label="Chart" />
          </Tabs>
        </Box>
        <CustomTabPanel value={selectedTab} index={0}>
          <DashboardData tile={props.tile} card={props.card}/>
        </CustomTabPanel>
        <CustomTabPanel value={selectedTab} index={1}>
          <DashboardCharts tile={props.tile} card={props.card}/>
        </CustomTabPanel>
      </Box>
    </Box>
  );
};

export default memo(DashboardDetails);
